<tabs-inner-wrap>
  @if (isSelfAuthoring()) {
    <personal-information [isSelfAuthoring]="isSelfAuthoring()" [conversePromptManualOverride]="conversePromptManualOverride()"></personal-information>
    <generated-simulation-information [isRefinementBlocked]="conversePromptManualOverride()"></generated-simulation-information>
  } @else {
    <simulation-information></simulation-information>
  }
  @if (!isSelfAuthoring()) {
    <personal-information [isSelfAuthoring]="isSelfAuthoring()"></personal-information>
  }
  @if (!isSelfAuthoring()) {
    <simulation-details-information></simulation-details-information>
  }
</tabs-inner-wrap>
